exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".popover{width:30%;max-width:100%!important;box-shadow:0 0 20px #333}.popover-title{font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-3fb6b198!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/HistoryItem.vue
// module id = 198
// module chunks = 0